import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Grid, Paper, Typography, Avatar } from '@mui/material';
import {
    setEventDetailView, removeEventDetailView, eventDetailViewSelector,
    getEventAddress, deleteTroubleEvent,
} from '../../features/events/eventsSlice';
import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { removeDetailView, assetNamesSelector } from '../../features/assets/assetsSlice';
import { setCenter, setMapControl, setZoom } from '../../features/map/mapSlice';

import eventIcons from '../../utils/eventIcons.js';


const EventListCard = ({ eventId, index }) => {


    const dispatch = useDispatch();
    const eventDetailView = useSelector(eventDetailViewSelector);
    const dimentions = useSelector(liveTrackinglayoutSelector);

    const eventData = useSelector(state => state.events.eventContent[`${eventId}`]);

    const assetID = eventData ? `${eventData.assetID}` : null;
    const assetNames = useSelector(assetNamesSelector);
    const regn = assetNames && assetNames[assetID] && assetNames[assetID].regn;

    const toggleEventDetails = () => {
        if (eventData.event_id === eventDetailView) {
            dispatch(removeEventDetailView());
            dispatch(setMapControl('asset'));
        } else {
            dispatch(removeDetailView());
            dispatch(getEventAddress({
                searchParam: {
                    eventId: eventData.event_id,
                    lat: eventData.lat,
                    lng: eventData.lng,
                    regn: regn
                }
            }));
            dispatch(setEventDetailView(eventData.event_id));
            dispatch(setCenter({
                lat: parseFloat(eventData.lat),
                lng: parseFloat(eventData.lng),
            }))
            dispatch(setZoom(17));
            dispatch(setMapControl('event'));
        }

    }

    const [flashIt, setFlashIt] = useState(false);
    useEffect(() => {
        let flashInterval;
        if (eventId && index === -1) {
            flashInterval = setInterval(() => {
                if (moment().diff(moment(eventData.event_time), 'seconds') < 90) {
                    //console.log("exec", eventData, moment().diff(moment(eventData.event_time), 'seconds'));
                    setFlashIt(!flashIt);
                } else {
                    if (flashInterval) {
                        //console.log("kill timeout");
                        clearInterval(flashInterval);
                    }
                }
            }, 2000);
        }
        return () => {
            //console.log("kill exit ");
            clearInterval(flashInterval);
        }
    }, [eventId, flashIt, index, eventData]);

    useEffect(() => {
        if (!regn) {
            dispatch(deleteTroubleEvent(eventId));
        }
    }, [regn, eventId, dispatch])

    useEffect(() => {
        //console.log("Ecvent Data list card", eventData, regn);
    }, [eventData, regn])


    if (eventData && regn) {
        return (
            <Paper
                style={{
                    margin: index === -1 ? '0px' : '3px',
                    width: index === -1 ? dimentions.eventFlashCard.width : dimentions.eventCard.width,
                    height: '90px', //index === -1 ? dimentions.eventFlashCard.height : dimentions.eventCard.height,
                    backgroundColor: index === -1 ? flashIt ? 'LightSteelBlue' : 'Silver' : eventData.event_id === eventDetailView ? 'LightYellow' : 'White',
                    transition: "all 2s ease",
                    WebkitTransition: "all 2s ease",
                    MozTransition: "all 2s ease"

                }}
                elevation={index === -1 ? 3 : 1}
                onClick={toggleEventDetails}
            >
                <Grid
                    item
                    sm={12}
                    container
                    direction="row"
                    justifyContent='space-between'
                    alignItems='center'
                    alignContent="stretch"
                    spacing={2}>
                    <Grid item sm={2}>
                        <div style={{ margin: '5px' }}>
                            <Avatar
                                style={{ backgroundColor: 'Azure' }}
                            >
                                {eventIcons(eventData.event_desc)}
                            </Avatar>
                        </div>
                    </Grid>
                    <Grid item sm={10}>
                        <div style={{ margin: '9px' }}>
                            <Grid
                                container
                                direction="row"
                                justifyContent='center'
                                alignItems='center'
                                alignContent="center"
                                spacing={2}
                            >
                                <Grid item sm={7}>
                                    <Fragment>
                                        <Typography
                                            variant="body1"
                                            color='textPrimary'
                                        >
                                            <span style={{ fontSize: 14, color: 'RoyalBlue' }}>
                                                <b>
                                                    {regn}
                                                </b>
                                            </span>
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            color='textPrimary'
                                        >
                                            <span style={{ fontSize: eventData.event_desc.length > 10 ? 14 : 20 }}>

                                                {eventData.event_desc}

                                            </span>
                                        </Typography>

                                    </Fragment>

                                </Grid>
                                <Grid item sm={5} container spacing={1} direction="column"
                                    justifyContent="space-between"
                                    alignItems="center">
                                    <Grid item sm={12}>
                                        <Typography
                                            variant="h5"
                                            style={{ display: "inline-block" }}
                                            color='textPrimary'
                                            display="inline"
                                        >
                                            {`${moment(eventData.event_time).format('h:mm')} `}
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            style={{ display: "inline-block" }}
                                            color='textSecondary'
                                            display="inline"
                                        >
                                            {` ${moment(eventData.event_time).format('A')}`}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={12}>
                                        <Typography
                                            variant="caption"
                                            style={{ display: "inline-block" }}
                                            color='textPrimary'
                                        >

                                            <b>{`${moment(eventData.event_time).format('Do MMM YY')}`}</b>
                                        </Typography>
                                    </Grid>


                                </Grid>

                                {/*<Grid item sm={12}>
                                    <Fragment>
                                        <Typography
                                            variant="body1"
                                            color='textPrimary'
                                        >
                                            <span>
                                                <b>
                                                    {eventData.event_desc}
                                                </b>
                                            </span>
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color='textPrimary'
                                        >
                                            {regn}
                                        </Typography>
                                    </Fragment>

                                </Grid>
                                <Grid item sm={12}>
                                    <Typography
                                        variant="subtitle2"
                                        style={{ display: "inline-block" }}
                                        color='textPrimary'
                                    >
                                        {`${moment(eventData.event_time).format('Do MMM YY hh:mm:ss A')}`}
                                    </Typography>
            </Grid>*/}

                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        );
    } else {
        //console.log("Trouble event", eventData, regn, assetNames);
        //dispatch(deleteTroubleEvent(eventId));
        return null;
    }
}

export default React.memo(EventListCard);